module.exports = __webpack_public_path__ + "static/media/operations-feature-tile-icon-01.03ef4872.svg";